export enum OrderPaymentMethodCode {
    BANCONTACT = "BANCONTACT",
    CREDITCARD = "CREDITCARD",
    GIFTCARD = "GIFTCARD",
    COUPON = "COUPON",
    PAY_IN_STORE = "PAY_IN_STORE",
    TERMINAL = "TERMINAL",
    VOUCHER = "VOUCHER",
    KLARNA = "KLARNA"
}
